
const REACT_APP_VERSION = process.env.REACT_APP_VERSION;

function Footer() {
    return (
        <>
            {/* <!-- Footer --> */}
            <footer className="bg-white iq-footer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6">
                            {/* <ul className="list-inline mb-0">
                                <li className="list-inline-item"><a href="privacy-policy.html">Privacy Policy</a></li>
                                <li className="list-inline-item"><a href="terms-of-service.html">Terms of Use</a></li>
                            </ul> */}
                        </div>
                        <div className="col-lg-6 text-right">
                            &copy;{new Date().getFullYear() + ' '}, All Rights Reserved. <a href="#"> Version: {REACT_APP_VERSION} </a>
                        </div>
                    </div>
                </div>
            </footer>
            {/* <!-- Footer END --> */}
        </>
    )
}

export default Footer;
